import { render, staticRenderFns } from "./myGroups.vue?vue&type=template&id=0b55b15f&scoped=true&lang=pug"
import script from "./myGroups.vue?vue&type=script&lang=js"
export * from "./myGroups.vue?vue&type=script&lang=js"
import style0 from "./myGroups.vue?vue&type=style&index=0&id=0b55b15f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b55b15f",
  null
  
)

export default component.exports